import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bs-range',
  templateUrl: './range.component.html',
  styleUrls: ['./range.component.css']
})
export class RangeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
